<template>
  <div
    class="song-text"
    :style="{left: `${node.y}px`, top: `${node.x}px`}"
  >
    <a
      role="button"
      class="title"
      @click="toSong(node.data)"
    >{{ $truncate(node.data.title) }}</a>

    <br>

    <span class="details">
      <span>{{ node.data.country_origin || "Country of origin unknown" }}</span>
      <span>, {{ node.data.year || "Unknown date" }}</span>
    </span><br>

    <span class="artists">
      <a
        v-if="authors.length > 0"
        role="button"
        class="artist"
        @click="toArtist(authors[0])"
      >
        <span class="icon is-small">
          <i class="mdi mdi-pencil" />
        </span>
        <span>{{ $truncate(authors[0].name) }} </span>
        <b-tooltip
          v-if="authors.length > 1"
          :label="authors.slice(1, authors.length).map(i => i.name).join(', ')"
          type="is-dark"
          multilined
        >
          <span> (...) </span>
        </b-tooltip>
      </a>
      <a
        v-if="interprets.length > 0"
        role="button"
        class="artist"
        @click="toArtist(interprets[0])"
      >
        <span class="icon is-small">
          <i class="mdi mdi-microphone" />
        </span>
        <span>{{ $truncate(interprets[0].name) }} </span>
        <b-tooltip
          v-if="interprets.length > 1"
          :label="interprets.slice(1, interprets.length).map(i => i.name).join(', ')"
          type="is-dark"
          multilined
        >
          <span> (...) </span>
        </b-tooltip>
      </a>
      <a
        v-if="composers.length > 0"
        role="button"
        class="artist"
        @click="toArtist(composers[0])"
      >
        <span class="icon is-small">
          <i class="mdi mdi-music" />
        </span>
        <span>{{ $truncate(composers[0].name) }} </span>
        <b-tooltip
          v-if="composers.length > 1"
          :label="composers.slice(1, composers.length).map(i => i.name).join(', ')"
          type="is-dark"
          multilined
        >
          <span> (...) </span>
        </b-tooltip>
      </a>
    </span>
  </div>
</template>

<script>

import { toSong, toArtist } from "@/services/navigator.js";

export default {
	props: {
		node: {
			required: true
		}
	},
	computed: {
		song () {
			return this.node.data;
		},
		authors () {
			return this.song.author_ids.map(id => {
				return this.$store.state.artists[id];
			});
		},
		interprets () {
			return this.song.interpret_ids.map(id => {
				return this.$store.state.artists[id];
			});
		},
		composers () {
			return this.song.composer_ids.map(id => {
				return this.$store.state.artists[id];
			});
		}
	},
	methods: {
		toSong (song) {
			toSong(song.id);
		},
		toArtist (artist) {
			toArtist(artist.id);
		}
	},
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/_variables.scss';
.song-text {
    position: absolute;
    display: inline-block;
    padding: 0.5rem 0.8rem;
    background-color: rgba(255,255,255,0.8);
    width: 360px;
    box-shadow: $box-shadow;
    font-size: 0.9rem;
    margin-left: 1px;
    margin-top: 1px;
    line-height: 1.2;

    .title {
        font-weight: 600;
        font-size: 0.9rem;
        line-height: 1.5;

        .icon {
            height: 1rem;
        }
    }
    .artists {
      display: block;
      margin-top: 5px;

    }
    .artist {
        color: $grey;
        line-height: 1;
        font-size: 0.75rem;
        margin-right: 5px;
    }
}

.icon.is-small {
    width: 0.7rem;
    margin-right: 0.2rem;
}
</style>
